module.exports = __webpack_public_path__ + "img/bottom.09efd88.png";